import angular from 'angular';
import onboardingAdditionalStaff from './onboardingAdditionalStaff';

export default angular
  .module('components.onboardingAdditionalStaff', [])
  .component('onboardingAdditionalStaff', onboardingAdditionalStaff).name;
